import React from "react";
import ProductBanner from "@/component/product-banner";
import RecomCharacteristics from "@/component/recom-characteristics";
import FaqsCompo from "@/component/faqs";
import ImageStepsCard from "@/component/image-steps-card";
import TVCard from "@/component/tv-card";
import ChannelList from "@/component/channel-list";
// import ImageStepsCard from "@/component/image-steps-card";

/**
 * @name Layout
 * @description Connectivity page layout
 * @param {any} props
 * @returns {React.FC}
 */

const Layout = (props) => {
  const {
    productName,
    orionAlias,
    orionInfo,
    orionProductListCategory,
    orionRules,
    orionProductCompatibilityGroup,
  } = props;

  return (
    <>
      {orionInfo.MODULO_BUYBOX && orionInfo.MODULO_CARACTERISTIC_CARDS && (
        <ProductBanner
          productName={productName}
          orionTitle={orionInfo.MODULO_H1}
          orionBanner={orionInfo.MODULO_BANNER}
          orionBuyBox={orionInfo.MODULO_BUYBOX}
          orionSelector={orionInfo.MODULO_SELECTOR}
          orionCharacs={orionInfo.MODULO_CARACTERISTIC_CARDS}
          orionImageSlider={orionInfo.MODULE_SECTION_IMAGE_SLIDER}
          simphePhoneFicha={orionInfo.MODULO_SIMPLEPHONE_FICHA}
          orionAlias={orionAlias}
          orionProductListCategory={orionProductListCategory}
          orionProductCompatibilityGroup={orionProductCompatibilityGroup}
          orionRules={orionRules}
        />
      )}

      {orionInfo.MODULO_RECOMENDACION && (
        <RecomCharacteristics {...orionInfo.MODULO_RECOMENDACION} />
      )}

      {orionInfo.MODULO_PACK_CARD && (
        <TVCard {...orionInfo.MODULO_PACK_CARD} module="MODULO_PACK_CARD" />
      )}

      {props.MODULO_SIMPLE_CARD && (
        <TVCard {...orionInfo.MODULO_SIMPLE_CARD} module="MODULO_SIMPLE_CARD" />
      )}

      {props && props.MODULE_DESCRIPTION_IMG && (
        <ImageStepsCard {...orionInfo.MODULE_DESCRIPTION_IMG} />
      )}

      {props && props.MODULO_CATEGORY_PACK_TV && (
        <ChannelList
          title={orionInfo.MODULO_CATEGORY_PACK_TV["Text-1"]}
          channelList={orionInfo.MODULO_CATEGORY_PACK_TV["Channels-1"]}
        />
      )}

      {orionInfo && orionInfo.FAQS_PREGUNTAS_FRECUENTES && (
        <FaqsCompo {...orionInfo.FAQS_PREGUNTAS_FRECUENTES} />
      )}
    </>
  );
};

export default Layout;
